import store from '../store';

const notify = ({type, title, message}) => {
    store.dispatch('Notification/add', {type, title, message})
};

const error = ({title, message}) => {
    notify({type: 'error', title, message})
};

const success = ({title, message}) => {
    notify({type: 'success', title, message})
};

export default {
    notify,
    error,
    success
}